export default[
    {
        name: 'environmentMapTexture',
        type: 'cubeTexture',
        path:[
            'textures/environmentMap/px.jpg',
            'textures/environmentMap/nx.jpg',
            'textures/environmentMap/py.jpg',
            'textures/environmentMap/ny.jpg',
            'textures/environmentMap/pz.jpg',
            'textures/environmentMap/nz.jpg'
        ]
    },
   
    {
        name: 'drop',
        type: 'texture',
        path: 'textures/natur/dråpe.png'
    },
    {
        name: 'snowflake',
        type: 'texture',
        path: 'textures/natur/snøfnugg.png'
    },
    {
        name: 'cloudTextue',
        type: 'texture',
        path: 'textures/sky/clouds-png-3.png'
    },
    {
        name: "musicCornfieldChase",
        type: "music",
        path: "models/Kassert/Cornfield-chase.mp3",
      },
      {
        name: "refleksjon",
        type: "hdr",
        path: "textures/rural_crossroads_1k.hdr",
      },
      {
        name: "blokk",
        type: "gltfModel",
        path: "models/FantoftCity/blokk.glb",
      },
      {
        name: "rør",
        type: "gltfModel",
        path: "models/FantoftCity/rør.glb",
      },
     
    
]